/* eslint-disable react/prop-types */
import Joyride from 'react-joyride';

export function TourGuide({steps, isOpen, onFinish, hideBackButton, hideCloseButton, hideSkipButton, hideNextButton, onNext=()=>null}) {
  return <Joyride
    run={isOpen}
    continuous={false}
    callback={(event)=>{
      if(event.status === 'running'){
        onNext(event)
      }
      if(event.status === 'finished'|| event.status === 'skipped'){
        onFinish(event.status) 
      } 
    }}
    disableScrollParentFix
    showSkipButton={true}

    styles={
      {
        buttonNext:{
          backgroundColor:'#9F00E4',
          color:'#fff',
          borderRadius:'10px',
          width:'auto',
          flex:1,
          padding:'15px 0px',
          outline:'none',
          display:hideNextButton ? 'none' : 'block'
        },
        buttonBack:{
          flex:1,
          color:'#9F00E4',
          border:'1px solid #9F00E4',
          borderRadius:'10px',
          width:'auto',  
          padding:'15px 0px',
          outline:'none',
          margin:0,
          display:hideBackButton ? 'none' : 'block'
        },
        buttonSkip:{
          color:'#9F00E4',
          border:'1px solid #9F00E4',
          borderRadius:'10px',
          width:'auto', 
          flex:1, 
          padding:'15px 0px',
          outline:'none',
          display:hideSkipButton ? 'none' : 'block'
        },
        buttonClose:{
          display:hideCloseButton ? 'none' : 'block'
        },
        tooltipFooter:{
          display:'flex',
          flexDirection:'row',
          gap:'10px',
          justifyContent:'space-between',
          flexShrink:'unset',
        },
        tooltip:{
          border:'2px solid #9F00E4',
     
        },
        tooltipFooterSpacer:{ 
          display:'flex',
          
        },
        beacon: {
          width: '50px',
          height: '50px',
        },
        spotlight:{
          borderRadius:10,
          padding:0,
          margin:0,
          width:'auto',
          border:'2px solid #9F00E4'
        },

      } 
    }
    
    steps={steps}
  />
}
